import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=0efed5ed&scoped=true"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"
import style0 from "./ResetPassword.vue?vue&type=style&index=0&id=0efed5ed&prod&scoped=true&lang=css"
import style1 from "./ResetPassword.vue?vue&type=style&index=1&id=0efed5ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efed5ed",
  null
  
)

export default component.exports